import logo from './logo.svg';
import './App.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Header from './sections/Header';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import StudentLogin from './pages/auth/StudentLogin';
import NotFound from './components/PageNotFound/NotFound';
import TeacherDashboard from './components/Dashboard/Teacherdashboard';
import Cos_reg from "./pages/Teacher/CourseRegistration/Co_reg"
import Pos_reg from "./pages/Teacher/CourseRegistration/Pos_reg"


import User_course from "./pages/Teacher/CourseRegistration/User_course"
import ShowCos from   "./pages/Teacher/CourseRegistration/ShowCos"
import Coposhow from  "./pages/Teacher/CourseRegistration/ShowCopo"
import TermworkSelector from './pages/Teacher/TermWork/TermworkSelector';
import UploadTermworkQuestion from './pages/Teacher/TermWork/UploadTermworkQuestion';
import TermworkUpload from './pages/Teacher/TermWork/TermworkUpload';
import Result from './pages/Teacher/TermWork/Result';

// LMS Classroom
import LMSTeacherDashboard from "./components/Dashboard/LMSTeacherDashboard"
import ViewAllClassroom from './pages/Teacher/LMS/Classroom/ViewAllClassroom';
import ManageClassroom from './pages/Teacher/LMS/Classroom/ManageClassroom';
import ManageClassroomStudents from './pages/Teacher/LMS/Classroom/ManageClassroomStudents';


import CreateCohorts from './pages/Teacher/LMS/Cohorts/CreateCohorts';
import ManageCohorts from './pages/Teacher/LMS/Cohorts/ManageCohorts';
import ManageCohortStudents from './pages/Teacher/LMS/Cohorts/ManageCohortStudents';
import EditCohort from './pages/Teacher/LMS/Cohorts/EditCohort';
import ClassroomActivities from './pages/Teacher/LMS/Classroom/ClassroomActivities';
import AssignmentSubmissions from './pages/Teacher/LMS/Classroom/AssignmentSubmissions';
import StudentLmsAttendance from './pages/Teacher/LMS/Attendance/StudentLmsAttendance';



// Admin

import UserSelection from "./pages/Admin/UserSelection/UserSelection"
import AssignCourse from "./pages/Admin/UserSelection/AssignCourse"
import EditPOs from "./pages/Admin/EditPOs"
import AdminCOs_course  from "./pages/Teacher/CourseRegistration/EditCOs"
import NextSemButton  from "./pages/Admin/NextSem"
import Course_reg from "./pages/Admin/Course_reg"
import Admin_Cos_Edit  from "./pages/Teacher/CourseRegistration/COsData"
import AdminSideShowCOs  from "./pages/Admin/AdminSideShowCOs"
import AdminSideEditCourse  from "./pages/Admin/AdminSideEditCourse"
import RegistrationForm from "./pages/Admin/RegisterForm"
import CourseWiseReports from './pages/Admin/Reports/CourseReports';
import FacultyWiseReports from  './pages/Admin/Reports/FacultyWiseReports';
import SemesterWiseReports from  './pages/Admin/Reports/SemesterWiseReports';
import SetTargetReports from './pages/Admin/Reports/SetTargetReports';
// Student

import StudentlmsDashboard from './pages/Student/StudentlmsDashboard';
import ViewClassroom from './pages/Student/ViewAllClassroom';
import StudentClassRoomActivities from './pages/Student/StudentClassRoomActivities';
import ActivityDetail from './pages/Student/Activitydetails';
// import StudentSideFeedback from './pages/Student/StudentSideFeedback';
import ViewFeedback from './pages/Student/ViewFeedback';
import Feedback from './pages/Teacher/TermWork/Feedback';
import StudentFeedback from './pages/Student/StudentFeedback';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import AllSubjectWiseAttendance from './pages/Teacher/LMS/Attendance/AllSubjectWiseAttendance';
import CourseOutcomeWiseReports from './pages/Admin/Reports/CourseOutComeWiseReports';
import UserWiseDetails from './pages/Admin/Reports/UserwiseReport';
import CourseresultReports from './pages/Admin/Reports/CourseresultReports';



function App() {
  const [token, setToken] = useState("");
  const [user_id, setUID] = useState(0);
  const [sid,setSID]=useState(0)
  const [usertype, setUserType] = useState(0);


  useEffect(() => {
    const storedToken = window.localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);

      const uid = window.localStorage.getItem("uid");
      const sid = window.localStorage.getItem("sid");
      const user_type = window.localStorage.getItem("user_type");

      if (user_type) {
        setUserType(parseInt(user_type));
      }
      if (uid) {
        setUID(parseInt(uid));
      }
      if (sid) {
        setSID(parseInt(sid));
      }
    }
  }, []);

  return (
    <main className="overflow-hidden">
      <Header />
      <Routes>
        {token  &&  (user_id || sid)  ? (
          usertype === 1  && sid ? (
            <>
              {/* Define routes for usertype === 1 */}
              <Route path="/" element={<StudentlmsDashboard uid={sid} />} />
              <Route path="/viewclassroom" element={<ViewClassroom uid={sid} />} />
              <Route path="/viewclassroom/:classroomId" element={<StudentClassRoomActivities uid={sid} />} />
              <Route path="/lms/activity-detail/:id" element={<ActivityDetail  uid={sid} />} />
              {/* <Route path="/feedback-student" element={<StudentSideFeedback uid={sid} />} /> */}
              <Route path="/student-feedback/:usercourseid" element={<ViewFeedback sid={sid}/>} />
              <Route path="/student-feedback" element={<StudentFeedback sid={sid} />} />

              <Route path="*" element={<NotFound />} />
            </>
          ) : usertype === 2 && user_id ? (
            <>
              {/* Define routes for usertype === 2 */}
              <Route path='/' element={<TeacherDashboard />} />
              <Route path="/coform" element={<Cos_reg />} />
              <Route path="/editcos" element={<AdminCOs_course uid={user_id} />}/>
              <Route path="/addremovecos" element={<Admin_Cos_Edit />}/>
              <Route path="/posform" element={<Pos_reg />} />
              <Route path="/courseform" element={<Course_reg />} />
              <Route path='/registerform' element={<RegistrationForm uid={user_id}/>} />
              <Route path='/usercourse' element={<User_course uid={user_id}/>} />
              <Route path='/cos' element={<ShowCos />} />
              <Route path='/coposhow' element={<Coposhow  uid={user_id}/>} />
              <Route path='/termwork-selector' element={<TermworkSelector  uid={user_id}/>} />
              <Route path='/upload-questions' element={<UploadTermworkQuestion  uid={user_id}/>} />
              <Route path='/Upload-Termwork' element={<TermworkUpload  uid={user_id}/>} />
              <Route path='/result' element={<Result  uid={user_id}/>} />
              <Route path='/feedback' element={<Feedback uid={user_id}/>} />
         

              {/* LMS Classroom */}
              
              <Route path='/lms' element={<LMSTeacherDashboard  uid={user_id}/>} />
              <Route path='/lms/viewclassroom' element={<ViewAllClassroom uid={user_id}/>} />
              <Route path='/lms/manageclassroom' element={<ManageClassroom uid={user_id}/>} />
              <Route path='/lms/manageclassroom/:classId' element={<ManageClassroomStudents uid={user_id}/>} />

              <Route path='/lms/createcohorts' element={<CreateCohorts uid={user_id}/>} />
              <Route path='/lms/managecohorts' element={<ManageCohorts uid={user_id}/>} />
              <Route path='/lms/managestudents/:cohortId' element={<ManageCohortStudents uid={user_id}/>} />
              <Route path="/lms/editcohort/:cohortId" element={<EditCohort uid={user_id}/>} />

              {/* classroom activities */}
              <Route path= "/lms/viewclassroom/:classroomId" element={<ClassroomActivities uid={user_id}/>} />
              <Route path="/lms/viewclassroom/:classroomId/submissions/:assignmentId" element={<AssignmentSubmissions  uid={user_id}/>} />
              {/* classroom activities */}

              <Route path='/lms/studentLmsAttendance' element={<StudentLmsAttendance uid={user_id}/>} />
              <Route path='/lms/AllstudentLmsAttendance' element={<AllSubjectWiseAttendance  uid={user_id}/>} />
              {/* LMS Classroom*/}

              <Route path="*" element={<NotFound />} />
            </>
          ) : usertype === 3 && user_id ? (
            <>
              {/* Define routes for usertype === 3 */}
              <Route path="/" element={<AdminDashboard />} />
              <Route path="/courseform" element={<Course_reg />} />
              <Route path='/registerform' element={<RegistrationForm uid={user_id}/>} />
              <Route path="/AssignCourse" element={<AssignCourse />} />
              <Route path="/EditPOs" element={<EditPOs />} />
             
              {/* <Route path="/nextsem" element={<NextSemButton />}/> */}
           
              <Route path="/adminshowcos" element={<AdminSideShowCOs />} />
              <Route path="/AdminEditCourse/:userCourseId" element={<AdminSideEditCourse />} />
              <Route path="/courseoutcomereports" element={<CourseOutcomeWiseReports uid={user_id} />} />
              <Route path="/set-target-reports" element={<SetTargetReports uid={user_id} />} />
              <Route path="/facultyreports" element={<FacultyWiseReports uid={user_id} />} />
              <Route path="/semesterwisereports" element={<SemesterWiseReports uid={user_id}/>} />
              <Route path="/userwisedetails" element={<UserWiseDetails uid={user_id}/>} />
              <Route path="/coursewisereports" element={<CourseWiseReports uid={user_id}/>} />
              <Route path="/courseresultreports" element={<CourseresultReports uid={user_id}/>} />
              <Route path="*" element={<NotFound />} />
            </>
          ) : (
            <>
              {/* Fallback for invalid user types */}
              <Route path="/teacher" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<StudentLogin />} />
          
            </>
          )
        ) : (
          <>
            {/* Public routes */}
            <Route path="/teacher" element={<Login />} />
            <Route path="/teacher/register" element={<Register />} />
            <Route path="/" element={<StudentLogin />} />
        
          </>
        )}
      </Routes>
    </main>
  );
}

export default App;
